export default __webpack_public_path__ + "static/media/login-bg.1a952e5d.jpg";